import { DiscoveryWallState } from '../../../models';
import { DISCOVERY_WALL_MUTATIONS_KEYS } from '../discovery-wall.const';
import { DiscoveryWallMutation } from '../discovery-wall.interfaces';

export class SetDiscoveryWallStateMutation implements DiscoveryWallMutation {
  mutations = {
    [DISCOVERY_WALL_MUTATIONS_KEYS.setDiscoveryWallState]: (state: DiscoveryWallState, newState: Partial<DiscoveryWallState>) => {
      Object.assign(state, newState);
    }
  };
}
